document.addEventListener("click", function (e) {
const icon = document.querySelector(".heart_icon");
if (icon) icon.style.display = "none";
  const btn = e.target.closest(".wishlist-btn");
  if (!btn) return;

  const handle = btn.getAttribute("data-product-handle");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const heartIcon = btn.querySelector(".heart_icon");
   

  if (!wishlist.includes(handle)) {
    wishlist.push(handle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    const span = btn.querySelector("span");
    if (span) span.textContent = " Added to Wishlist";
     if (heartIcon) {
    heartIcon.classList.add("added-wishlist-text");
  }
  } else {
    const span = btn.querySelector("span");
    if (span) span.textContent = " Already in Wishlist";
     if (heartIcon) {
    heartIcon.classList.add("in-wishlist-text");
  }
    
}

});
